import Grid from '../../../../components/Grid'
import GridsNavigation from '../../../../components/Grid/components/GridsSidebar'
import usePreviewSubject from './usePreviewSubject'
import { handleGetGridDifficulty } from '../../../../utils'

const PreviewSubjectTab = ({ removeGrid, subject, onSuccessCreateSubject }) => {
  const {
    currentIndex,
    handleNextGrid,
    handlePrevGrid,
    handleCurrentGrid,
    setHeight,
    height,
    allTags,
    hints,
    handleGetHint,
    checkbox,
    setCheckbox,
    allowHint,
    setAllowHint,
  } = usePreviewSubject(subject)
  return (
    <div className="flex w-full gap-5 justify-center p-0 mt-2">
      <div className="w-full xl:w-fit">
        <Grid
          page={subject?.[currentIndex]?.page}
          allowHint={allowHint}
          removeGrid={removeGrid}
          onSuccessCreateSubject={onSuccessCreateSubject}
          handleCurrentGrid={handleCurrentGrid}
          source={subject?.[currentIndex]?.source}
          checkbox={checkbox}
          setCheckbox={setCheckbox}
          handleUserGetHint={handleGetHint}
          explanationPreview={subject?.[currentIndex]?.explain}
          hint={hints?.[currentIndex]}
          height={height}
          setHeight={setHeight}
          isCreateSubject
          showProgress={false}
          showSkeleton={false}
          answer={{
            correct_answer: subject?.[currentIndex]?.correct_answer,
          }}
          userChoice={subject?.[currentIndex]?.correct_answer}
          allTags={allTags}
          difficulty={handleGetGridDifficulty(
            subject?.[currentIndex]?.difficulty,
          )}
          gridTags={subject?.[currentIndex]?.tags}
          gridsFromSubject={subject}
          currentGridIndex={currentIndex}
          currentGridId={subject?.[currentIndex]?.id}
          isMultipleChoice={subject?.[currentIndex]?.multiple_choice}
          subjectCreate
          started
          isSubject
          currentGrila={subject[currentIndex]?.json}
          handleNextGrid={handleNextGrid}
          handlePrevGrid={handlePrevGrid}
        />
      </div>
      <div className="relative hidden xl:block">
        <GridsNavigation
          allowHint={allowHint}
          setAllowHint={setAllowHint}
          removeGrid={removeGrid}
          onSuccessCreateSubject={onSuccessCreateSubject}
          currentGridIndex={currentIndex}
          handleCurrentGrid={handleCurrentGrid}
          gridsFromSubject={subject}
          create
        />
      </div>
    </div>
  )
}

export default PreviewSubjectTab
